import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (dados: IPreencherATPVUnitario | null) => void;
  dados: IPreencherATPVUnitario | null;
  processos: { id: number }[];
}

export function ModalCertezaProcessosDuplicadosAtpv({
  show,
  handleClose,
  onConfirm,
  dados,
  processos,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Duplicação de processos"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={() => onConfirm(dados)}
      confirmButtonText="Sim"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        O veículo possui os seguintes processos criados com as mesmas
        características: {processos.map((p) => p.id).join(", ")}. Deseja criar
        um novo processo para este veículo mesmo assim?
      </ModalBody>
    </ModalCustom>
  );
}
